export default __webpack_public_path__ + "static/media/redThunder.d2f16f7e.png";